<template>
  <a class="px-1" v-if="modelValue" :href="`tel:${phonenumber}`">
    {{ modelValue }}
  </a>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [String],
      required: false,
      default: null
    }
  },
  computed: {
    phonenumber () {
      return this.modelValue ? this.formatPhone(this.modelValue) : null
    }
  }
}
</script>
